GatorSurvey.app.directive("gsRatingQuestion", ['surveyResponseService', GsRatingQuestion]);
function GsRatingQuestion(surveyResponseService) {
    return {
        restrict: 'AE',
        scope: {
            gsModel: "=ngModel",
            mode: "=?"
        },
        templateUrl: 'Assets/Scripts/App/Directives/Questions/Templates/RatingQuestionLive.html',
        controller: ['$scope', '$timeout', function ($scope, $timeout) {
           
            $scope.activeStylingId = GatorSurvey.models.guid();
            $scope.hoverPoint = -1;

            $scope.getNumber = function () {
                if (typeof $scope.gsModel === "undefined") 
                    return [];
                return new Array($scope.gsModel.quantity);
            };

            $scope.setHoverPoint = function(value) {
                $scope.hoverPoint = value + 1;
            };
            $scope.resetHoverPoint = function() {
                $scope.hoverPoint = -1;
            };
            $scope.setValue = function(setAt, value) {
                if (setAt === 1) {
                    $scope.gsModel.selectedValue = value + 1;
                } else {
                    $scope.gsModel.input = value + 1;
                    $scope.gsModel.selectedValue = value + 1;
                    surveyResponseService.updateResponseQuestion($scope.gsModel, value + 1);
                }
            };

            $scope.checkIndex = function (testAt, value) {
                var icon = "";
                switch (testAt) {
                    case 1:
                        icon = (value >= $scope.gsModel.selectedValue && value >= $scope.hoverPoint) ? $scope.gsModel.iconUnSelected : $scope.gsModel.iconSelected;
                        break;
                    case 2:
                        icon = (value >= $scope.gsModel.input && value >= $scope.hoverPoint) ? $scope.gsModel.iconUnSelected : $scope.gsModel.iconSelected;
                         
                        break;
                    default:
                        icon = (value > Math.floor($scope.gsModel.quantity / 2)) ? $scope.gsModel.iconUnSelected : $scope.gsModel.iconSelected;
                        break;
                }
                return icon.indexOf("fas ") > -1 || icon.indexOf("far ") > -1 ? icon : "fa" + icon;
            };

            $scope.bsActive = function (testAt, $index) {
               
                switch (testAt) {
                    case 1:
                        if ($index + 1 === $scope.gsModel.selectedValue && $index >= $scope.hoverPoint) {
                            return 'bts-active';
                        } else
                            return "";
                        break;
                    case 2:
                        if ($index <= $scope.gsModel.input || $index <= $scope.hoverPoint) {
                            return 'bts-active';
                        } else
                            return "";
                        break;
                    default:
                        if ($index < Math.floor($scope.gsModel.quantity / 2)) {
                            return 'bts-active';
                        } else
                            return "";
                        break;
                }
            };
           
                surveyResponseService.AddNewQuestion($scope.gsModel,
                    function(response) {
                        $timeout(function() {
                            if (response.answer !== "")
                                $scope.gsModel.input = parseInt(response.answer) - 1;
                            else
                                $scope.gsModel.input = 0;
                        });
                    });
            

        }]
    };
}